export default {
    description:
        "In the Recommend and Earn program, <b><span>{receiverBonusAmount}</span> bonus</b> for your first purchase <b>is waiting for you!</b>",
    captchaLanguage: "en",
    email: "Enter e-mail",
    password: "Enter password",
    showMore: "Read more",
    showLess: "Hide",
    userConsentError: "This statement is required",
    passwordRequired: "Password is required",
    passwordTooShort: "Password should have at least 6 digits",
    emailRequired: "E-mail is required",
    emailInvalid: "Please enter valid e-mail address",
    emailTooLong: "E-mail address cannot be longer than {maxSize} characters",
    modalConfirmationButton: "Next",
    popularCashbackBrands: {
        title: "Popular <b>cashback stores</b>",
        subTitle: "Find your favourite online store and <b>shop cheaper.</b>",
    },
    whatIsCashback: {
        title: "What is <b>cashback</b>",
        subTitle:
            "When you shop in online stores, <b>you can get some money back</b> - that's cashback. In goodie you will find almost 600 well-known online stores where you can get cashback.",
    },
    forgetPassword: "Forgot your password?",
    bannerTitle: "<b>Get money refunds</b> for shopping",
    bannerText: "Shop at your favorite online stores and get part of money you spent back.",
    socialLoginError:
        "We could not find a goodie account for you to log in to. Please use the registration form and create new goodie account.",
};
